/*
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";

const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    connectionString: process.env.REACT_APP_AZURE_APP_INSIGHTS,
    extensions: [reactPlugin],
    enableAutoRouteTracking: true, // Automatically tracks page views on route change
  },
});

appInsights.loadAppInsights();

// Define and add the Telemetry Initializer
const telemetryInitializer = (envelope: { tags?: Record<string, string> }) => {
  // Check if tags exist before assigning
  envelope.tags = envelope.tags || {};
  envelope.tags["ai.cloud.role"] = `fa-${process.env.NODE_ENV}-web-digitalfarmer`;
};

appInsights.addTelemetryInitializer(telemetryInitializer);

export { appInsights, reactPlugin };
